import React from 'react'
import MessengerCustomerChat from 'react-messenger-customer-chat'

function Messenger () {
  return (
    <MessengerCustomerChat
      pageId='385021818308158'
      appId='263902037430900'
      themeColor='#000000'
      greetingDialogDisplay='hide'
    />
  )
}

export default Messenger
